import React, { useRef } from 'react';
import Head from 'next/head';

import { useProductCard } from '@/components/categ/CategCU/useProductCard';
import { isProductTtc } from '@/utils/productUtils';

import ProductImage from '@/components/product/ProductImage';
import ProductCardName from '@/components/listing/ProductCardName';
import Dropdown from '@/components/common/design-system/Dropdown.ds';
import WishListIcon from '@/components/account/wishList/WishListIcon';
import MillesimaPrice from '@/components/common/price/MillesimaPrice';
import AvailabilityIndicator from '@/components/common/AvailabilityIndicator';
import ProductCardAttributes from '@/components/listing/ProductCardAttributes';
import ProductRatingList from '@/components/common/product/rating/ProductRatingList';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './ProductCardCU.module.scss';

export const ProductCardCU = ({ product, index, currentItem, isCU, visibilityTracking }) => {
  const presenter = useProductCard(product, currentItem, visibilityTracking);
  const isTtc = isProductTtc(product, currentItem);

  return (
    <>
      {index <= 3 && (
        <Head>
          <link rel="preload" href={presenter.url} as="image" />
        </Head>
      )}
      <div className={styles.container} ref={presenter.productCardRef}>
        <div className={styles['ratings-bio-label']}>
          <ProductRatingList
            ratings={presenter.ratings}
            ratingMaxNumber={presenter.isMobile ? 1 : 3}
            onClick={presenter.handleClickProduct}
          />
        </div>
        <div className={styles.wishlist}>
          <WishListIcon
            product={{
              ...product,
              partnumber: presenter.currentItem.partnumber.split('/').slice(0, 2).join('/'),
            }}
          />
        </div>
        <ProductImage
          onClick={presenter.handleClickProduct}
          customClassName={styles['product-img']}
          url={presenter.url}
          alt={presenter.productName}
          position={index}
        />

        {presenter.ribbonad && (
          <div className={styles.ribbonad} data-test-id="ribbonad">
            {presenter.ribbonad.value}
          </div>
        )}
        <ProductCardName
          className={styles['title']}
          index={index}
          product={product}
          currentItem={presenter.currentItem}
          storeConf={presenter.storeConf}
        />
        <ProductCardAttributes {...presenter.productAttributes} index={index} customClassName={styles.attributes} />

        <MillesimaPrice
          className={{ container: styles.price, vat: styles.vat }}
          value={presenter.currentItem.offerPrice}
          vat={{
            display: true,
            included: isTtc
          }}
        />

        {!isCU && (
          <Dropdown
            id="item-selector"
            customClassName={styles['item-selector']}
            value={presenter.capacity?.value}
            options={presenter.getDropdownOptions()}
            onChange={(partnumber: string) => presenter.onItemChange(partnumber)}
            isDisabled={presenter.productModel.itemsList.length === 0}
            size="small"
            isReadOnly={product.items?.length === 1}
          />
        )}
        <div className={styles.actions}>
          {presenter.currentItem?.stock > 0 &&
              presenter.quantities.length > 0 &&
              !presenter.isMobile && (
            <Dropdown
              value={presenter.quantity}
              options={presenter.quantities}
              onChange={(value) => presenter.setQuantity(value)}
              size="small"
            />
          )}
          <CallToActionContainer
            {...presenter.buttonProps}
            labelClassName={styles.label}
            sensefuelId="add-to-cart"
            fullWidth
          >
            {presenter.buttonLabel}
          </CallToActionContainer>
        </div>
        <AvailabilityIndicator
          t={presenter.t}
          product={product}
          currentItem={presenter.currentItem}
          storeId={presenter.storeConf.storeId}
          locale={presenter.storeConf.locale}
          customClassName={styles['availability-indicator']}
          labelClassName={styles.label}
        />
      </div>
    </>
  );
};

export default ProductCardCU;
